export default [
  {
    label: '体重',
    keySearch: 'weight_range',
    options: [
      {
        label: '不足',
        range: 1,
        value: 0,
        key: 'weight_verylow_ratio',
        color: 'purple',
      },
      {
        label: '低い',
        range: 2,
        value: 0,
        key: 'weight_low_ratio',
        color: 'blue',
      },
      {
        label: '標準',
        range: 3,
        value: 0,
        key: 'weight_standard_ratio',
        color: 'green',
      },
      {
        label: '高い',
        range: 4,
        value: 0,
        key: 'weight_high_ratio',
        color: 'yellow',
      },
      {
        label: '超過',
        range: 5,
        value: 0,
        key: 'weight_veryhigh_ratio',
        color: 'red',
      },
    ],
  },
  {
    label: '体脂肪率',
    keySearch: 'body_fat_rate_range',
    options: [
      {
        label: '低い',
        range: 2,
        value: 0,
        key: 'body_fat_rate_low_ratio',
        color: 'blue',
      },
      {
        label: '標準',
        range: 3,
        value: 0,
        key: 'body_fat_rate_standard_ratio',
        color: 'green',
      },
      {
        label: '高い',
        range: 4,
        value: 0,
        key: 'body_fat_rate_high_ratio',
        color: 'yellow',
      },
      {
        label: '超過',
        range: 5,
        value: 0,
        key: 'body_fat_rate_veryhigh_ratio',
        color: 'red',
      },
      {
        label: '計測なし',
        range: 0,
        value: 100,
        key: 'body_fat_rate_unused_ratio',
        color: 'dark',
      },
    ],
  },
  {
    label: '体水分率',
    keySearch: 'body_water_rate_range',
    options: [
      {
        label: '低い',
        range: 2,
        value: 0,
        key: 'body_water_rate_low_ratio',
        color: 'blue',
      },
      {
        label: '標準',
        range: 3,
        value: 0,
        key: 'body_water_rate_standard_ratio',
        color: 'green',
      },
      {
        label: '十分',
        range: 4,
        value: 0,
        key: 'body_water_rate_high_ratio',
        color: 'primary',
      },
      {
        label: '計測なし',
        range: 0,
        value: 100,
        key: 'body_water_rate_unused_ratio',
        color: 'dark',
      },
    ],
  },
  {
    label: '基礎代謝',
    keySearch: 'BMR_range',
    options: [
      {
        label: '低い',
        range: 2,
        value: 0,
        key: 'BMR_low_ratio',
        color: 'blue',
      },
      {
        label: '高い',
        range: 4,
        value: 0,
        key: 'BMR_high_ratio',
        color: 'yellow',
      },
      {
        label: '計測なし',
        range: 0,
        value: 100,
        key: 'BMR_unused_ratio',
        color: 'dark',
      },
    ],
  },
  {
    label: '体内年齢',
    keySearch: 'metabolic_age_range',
    options: [
      {
        label: '低い',
        range: 2,
        value: 0,
        key: 'metabolic_age_low_ratio',
        color: 'blue',
      },
      {
        label: '高い',
        range: 4,
        value: 0,
        key: 'metabolic_age_high_ratio',
        color: 'yellow',
      },
      {
        label: '計測なし',
        range: 0,
        value: 100,
        key: 'metabolic_age_unused_ratio',
        color: 'dark',
      },
    ],
  },
  {
    label: '骨格筋',
    keySearch: 'muscle_rate_range',
    options: [
      {
        label: '低い',
        range: 2,
        value: 0,
        key: 'muscle_rate_low_ratio',
        color: 'blue',
      },
      {
        label: '標準',
        range: 3,
        value: 0,
        key: 'muscle_rate_standard_ratio',
        color: 'green',
      },
      {
        label: '高い',
        range: 4,
        value: 0,
        key: 'muscle_rate_high_ratio',
        color: 'yellow',
      },
      {
        label: '計測なし',
        range: 0,
        value: 100,
        key: 'muscle_rate_unused_ratio',
        color: 'dark',
      },
    ],
  },
  {
    label: '骨量',
    keySearch: 'bone_mass_range',
    options: [
      {
        label: '低い',
        range: 2,
        value: 0,
        key: 'bone_mass_low_ratio',
        color: 'blue',
      },
      {
        label: '標準',
        range: 3,
        value: 0,
        key: 'bone_mass_standard_ratio',
        color: 'green',
      },
      {
        label: '高い',
        range: 4,
        value: 0,
        key: 'bone_mass_high_ratio',
        color: 'yellow',
      },
      {
        label: '計測なし',
        range: 0,
        value: 100,
        key: 'bone_mass_unused_ratio',
        color: 'dark',
      },
    ],
  },
  {
    label: '皮下脂肪',
    keySearch: 'subcutaneous_fat_range',
    options: [
      {
        label: '低い',
        range: 2,
        value: 0,
        key: 'subcutaneous_fat_low_ratio',
        color: 'blue',
      },
      {
        label: '標準',
        range: 3,
        value: 0,
        key: 'subcutaneous_fat_standard_ratio',
        color: 'green',
      },
      {
        label: '高い',
        range: 4,
        value: 0,
        key: 'subcutaneous_fat_high_ratio',
        color: 'yellow',
      },
      {
        label: '計測なし',
        range: 0,
        value: 100,
        key: 'subcutaneous_fat_unused_ratio',
        color: 'dark',
      },
    ],
  },
  {
    label: '内臓脂肪',
    keySearch: 'visceral_fat_range',
    options: [
      {
        label: '標準',
        range: 2,
        value: 0,
        key: 'visceral_fat_low_ratio',
        color: 'green',
      },
      {
        label: '高い',
        range: 3,
        value: 0,
        key: 'visceral_fat_standard_ratio',
        color: 'yellow',
      },
      {
        label: '超過',
        range: 4,
        value: 0,
        key: 'visceral_fat_high_ratio',
        color: 'red',
      },
      {
        label: '計測なし',
        range: 0,
        value: 100,
        key: 'visceral_fat_unused_ratio',
        color: 'dark',
      },
    ],
  },
  {
    label: 'BMI',
    keySearch: 'BMI_range',
    options: [
      {
        label: '低い',
        range: 2,
        value: 0,
        key: 'BMI_low_ratio',
        color: 'blue',
      },
      {
        label: '標準',
        range: 3,
        value: 0,
        key: 'BMI_standard_ratio',
        color: 'green',
      },
      {
        label: '高い',
        range: 4,
        value: 0,
        key: 'BMI_high_ratio',
        color: 'yellow',
      },
      {
        label: '計測なし',
        range: 0,
        value: 100,
        key: 'BMI_unused_ratio',
        color: 'dark',
      },
    ],
  },
  {
    label: '総筋肉量',
    keySearch: 'muscle_mass_range',
    options: [
      {
        label: '低い',
        range: 2,
        value: 0,
        key: 'muscle_mass_low_ratio',
        color: 'blue',
      },
      {
        label: '標準',
        range: 3,
        value: 0,
        key: 'muscle_mass_standard_ratio',
        color: 'green',
      },
      {
        label: '十分',
        range: 4,
        value: 0,
        key: 'muscle_mass_high_ratio',
        color: 'primary',
      },
      {
        label: '計測なし',
        range: 0,
        value: 100,
        key: 'muscle_mass_unused_ratio',
        color: 'dark',
      },
    ],
  },
  {
    label: 'タンパク質',
    keySearch: 'protein_range',
    options: [
      {
        label: '低い',
        range: 2,
        value: 0,
        key: 'protein_low_ratio',
        color: 'blue',
      },
      {
        label: '標準',
        range: 3,
        value: 0,
        key: 'protein_standard_ratio',
        color: 'green',
      },
      {
        label: '十分',
        range: 4,
        value: 0,
        key: 'protein_high_ratio',
        color: 'primary',
      },
      {
        label: '計測なし',
        range: 0,
        value: 100,
        key: 'protein_unused_ratio',
        color: 'dark',
      },
    ],
  },
]
